import { request } from '@umijs/max';
import BASEURLCONFIG from '../../../config/BASEURLCONFIG';

// 用户端试用接口走 MES 服务，由后端再带内部密钥代理到平台端。
const VERSION_TRIAL_API = `${BASEURLCONFIG.ISWAN_MES_URL}/api/versionTrial`;

const unwrapVersionTrialResponse = (response: any) => {
  if (!response || typeof response !== 'object') {
    return response;
  }

  if (Object.prototype.hasOwnProperty.call(response, 'code') && Object.prototype.hasOwnProperty.call(response, 'data')) {
    return response.data || {};
  }

  if (
    response.data &&
    typeof response.data === 'object' &&
    (Object.prototype.hasOwnProperty.call(response.data, 'trialStatus') ||
      Object.prototype.hasOwnProperty.call(response.data, 'trialActive'))
  ) {
    return response.data;
  }

  return response;
};

export async function getVersionTrialCurrent() {
  const response = await request(`${VERSION_TRIAL_API}/current`, {
    method: 'GET',
  });
  return unwrapVersionTrialResponse(response);
}

export async function startVersionTrial() {
  try {
    const response = await request(`${VERSION_TRIAL_API}/start`, {
      method: 'POST',
    });
    return unwrapVersionTrialResponse(response);
  } catch (error: any) {
    // 申请失败时把 URL 和状态码带出来，方便区分代理、平台端密钥、权限校验问题。
    const status = error?.response?.status || error?.data?.status || error?.status;
    const url = error?.response?.config?.url || error?.config?.url || `${VERSION_TRIAL_API}/start`;
    const message = error?.response?.data?.message || error?.data?.message || error?.message || '申请试用失败';
    throw new Error(`${message}${status ? `（${status}）` : ''}：${url}`);
  }
}

export async function closeVersionTrialReminder() {
  const response = await request(`${VERSION_TRIAL_API}/closeReminder`, {
    method: 'POST',
  });
  return unwrapVersionTrialResponse(response);
}
